import { useEffect, useRef } from "react";

export default function CursorGlow() {
  const dotRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    if (!dot) return;
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let x = mouseX;
    let y = mouseY;
    let raf;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      const target = e.target;
      const interactive = target.closest("a, button, [data-cursor='hover'], input, textarea, select");
      if (interactive) {
        dot.style.width = "56px";
        dot.style.height = "56px";
        dot.style.backgroundColor = "rgba(212,175,55,0.12)";
        dot.style.borderColor = "rgba(245,230,163,0.9)";
      } else {
        dot.style.width = "26px";
        dot.style.height = "26px";
        dot.style.backgroundColor = "transparent";
        dot.style.borderColor = "rgba(212,175,55,0.7)";
      }
    };

    const loop = () => {
      x += (mouseX - x) * 0.18;
      y += (mouseY - y) * 0.18;
      dot.style.left = `${x}px`;
      dot.style.top = `${y}px`;
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={dotRef} className="cursor-glow" aria-hidden="true" />;
}
